import * as Html from "../util/Html.ts";
export {init}
Html.registerWidget('widget/select-with-value',{init:init})

function init(select){
  var
    selectedValue = select.attr("data-fw-select-value");
  select
    .find( "option[value='"+selectedValue+"']")
    .prop('selected',true);
  
}